// Validation utility functions

export const validationUtils = {
  // Validate phone number (10 digits)
  validatePhone: (phone) => {
    const phoneRegex = /^\d{10}$/;
    return phoneRegex.test(phone);
  },

  // Validate email
  validateEmail: (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  },

  // Validate file
  validateFile: (file, maxSize = 10) => {
    if (!file) {
      return 'Please select a file';
    }

    // Check file size (maxSize in MB)
    const maxSizeBytes = maxSize * 1024 * 1024;
    if (file.size > maxSizeBytes) {
      return `File size must be less than ${maxSize}MB`;
    }

    // Check file type
    const allowedTypes = [
      'application/pdf',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'image/jpeg',
      'image/jpg',
      'image/png'
    ];

    if (!allowedTypes.includes(file.type)) {
      return 'File type not supported. Please upload PDF, DOC, DOCX, JPG, or PNG files';
    }

    return null; // No error
  },

  // Validate pincode (6 digits)
  validatePincode: (pincode) => {
    const pincodeRegex = /^\d{6}$/;
    return pincodeRegex.test(pincode);
  },

  // Validate age
  validateAge: (age, min = 14, max = 100) => {
    const ageNum = parseInt(age);
    return !isNaN(ageNum) && ageNum >= min && ageNum <= max;
  }
};
